import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PlanNotAccurate = function PlanNotAccurate(_ref) {
  var floorPlanUrl = _ref.floorPlanUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: style['container'],
    "data-testid": "Plan",
    children: [/*#__PURE__*/_jsx("div", {
      className: style['plan-not-accurate'],
      children: /*#__PURE__*/_jsx("img", {
        className: style['plan-image'],
        src: floorPlanUrl,
        alt: "\u041F\u043B\u0430\u043D \u044D\u0442\u0430\u0436\u0430"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: style['description'],
      children: /*#__PURE__*/_jsxs(UIHeading2, {
        textAlign: "center",
        children: ["\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043C\u044B \u043D\u0435 \u0437\u043D\u0430\u0435\u043C ", /*#__PURE__*/_jsx("br", {}), " \u0442\u043E\u0447\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430 \u044D\u0442\u0430\u0436\u0430"]
      })
    })]
  });
};